export const ADDTOCART = "ADDTOCART"
export const DECREMENT = "DECREMENT"